// src/pages/Ads/components/policyMap.js
import TermsPolicyFull20251102 from "./PolicyVersion/TermsPolicyFull20251102";
import TermsPolicyFull20251209 from "./PolicyVersion/TermsPolicyFull20251209";

import PrivacyPolicyFull20251112 from "./PolicyVersion/PrivacyPolicyFull20251112";
import PrivacyPolicyFull20251202 from "./PolicyVersion/PrivacyPolicyFull20251202";
import PrivacyPolicyFull20251209 from "./PolicyVersion/PrivacyPolicyFull20251209";

import PermissionFull from "./PolicyVersion/PermissionFull"
// 접근권한 정책도 버전 관리할 거면 여기에 import

export const POLICY_COMPONENTS = {
  // DB의 component_key와 매칭
  terms_20251112: TermsPolicyFull20251102,
  terms_20251209: TermsPolicyFull20251209,
  privacy_20251112: PrivacyPolicyFull20251112,
  privacy_20251202: PrivacyPolicyFull20251202,
  privacy_20251209: PrivacyPolicyFull20251209,
  permission_20251112: PermissionFull,
  // access_20250922: AccessPermissionFull,  // 나중에 추가 가능
};
